///img/preloader2.gif

var $ = require('jquery');

web = window.web = window.web || {};

web.Preloader = module.exports = function(options) {
    var t = this;
    t.instanceState = 'contructed';
    t.defaults = {

    }

    t.$elm = null;
    t.options = $.extend({}, t.defaults, options);

};

web.Preloader.prototype = {
    init: function(){
        var t = this;

        t._createPreloader();

    },

    _createPreloader: function(){
        var t = this;

        t.$elm = $("<div class='preloader'></div>");
        $("body").append(t.$elm);
        t.$elm.hide();

    },

    showPreloader: function(){
        var t = this;

        t.$elm.fadeIn(600);
    },

    show: function(){
        var t = this;

        t.showPreloader();
    },

    hidePreloader: function(){
        var t = this;

        t.$elm.fadeOut(600);
    },

    hide: function(){
        var t = this;

        t.hidePreloader();
    }

}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/Preloader.js